"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortFn = exports["default"] = exports.ORDER_DESC = exports.ORDER_ASC = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _TableHeaderCell = _interopRequireDefault(require("./TableHeaderCell"));
var _DataTable = require("./DataTable.styled");
var _Loading = _interopRequireDefault(require("./Loading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ORDER_ASC = exports.ORDER_ASC = 'asc';
var ORDER_DESC = exports.ORDER_DESC = 'desc';
var sortFn = exports.sortFn = function sortFn(rows, colId, order) {
  return rows.sort(function (a, b) {
    return order === ORDER_ASC ? a[colId] < b[colId] ? -1 : 1 : a[colId] > b[colId] ? -1 : 1;
  });
};
var DataTable = function DataTable(_ref) {
  var tableKey = _ref.tableKey,
    rows = _ref.rows,
    columns = _ref.columns,
    defaultSort = _ref.defaultSort,
    hover = _ref.hover,
    footer = _ref.footer,
    _onClick = _ref.onClick,
    sortFn = _ref.sortFn,
    isLoading = _ref.isLoading,
    typeBorder = _ref.typeBorder,
    dataSelectorTable = _ref.dataSelectorTable,
    dataSelectorRows = _ref.dataSelectorRows;
  var _useState = (0, _react.useState)(defaultSort.order),
    _useState2 = _slicedToArray(_useState, 2),
    order = _useState2[0],
    setOrder = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultSort.colId),
    _useState4 = _slicedToArray(_useState3, 2),
    orderByColId = _useState4[0],
    setOrderByColId = _useState4[1];
  var handleHeaderCellClick = function handleHeaderCellClick(colId, event) {
    var isAsc = orderByColId === colId && order === ORDER_ASC;
    var newOrder = isAsc ? ORDER_DESC : ORDER_ASC;
    setOrder(newOrder);
    setOrderByColId(colId);
    sortFn(colId, newOrder);
  };
  var handleKeyDown = function handleKeyDown(event, row) {
    ['Enter', ' '].includes(event.key) && _onClick(row);
  };
  return /*#__PURE__*/_react["default"].createElement(_DataTable.StyledTableContainer, {
    component: _material.Paper
  }, /*#__PURE__*/_react["default"].createElement(_material.Table, {
    "aria-label": "data table",
    "data-selector": dataSelectorTable || 'datatable-web-components'
  }, /*#__PURE__*/_react["default"].createElement(_material.TableHead, {
    "data-selector": "".concat(dataSelectorTable || 'datatable-web-components', "-head")
  }, /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, columns.map(function (column, ind) {
    return /*#__PURE__*/_react["default"].createElement(_TableHeaderCell["default"], {
      key: "column-".concat(column.id),
      sortable: column.sortable,
      colId: column.id,
      orderByColId: orderByColId,
      order: order,
      align: column.align,
      onClick: handleHeaderCellClick,
      styles: column.style
    }, column.label);
  }))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, {
    "data-selector": "".concat(dataSelectorTable || 'datatable-web-components', "-body")
  }, rows.map(function (row, ind) {
    return /*#__PURE__*/_react["default"].createElement(_DataTable.StyledTableRow, {
      tabIndex: hover ? '0' : undefined,
      key: "row-".concat(ind),
      hover: hover,
      onClick: function onClick(event) {
        return _onClick(row);
      },
      onKeyDown: function onKeyDown(event) {
        return handleKeyDown(event, row);
      },
      "data-selector": dataSelectorRows || 'datatable-web-components-rows'
    }, columns.map(function (column) {
      return /*#__PURE__*/_react["default"].createElement(_DataTable.StyledTableBodyCell, {
        key: "cell-".concat(ind, "-").concat(column.id),
        align: column.align || 'left',
        border: typeBorder || '1px solid'
      }, column.cellRenderer ? column.cellRenderer(row, column) : row[column.id]);
    }));
  }))), footer, /*#__PURE__*/_react["default"].createElement(_Loading["default"], {
    visible: isLoading
  }));
};
DataTable.propTypes = {
  tableKey: _propTypes["default"].string,
  rows: _propTypes["default"].array.isRequired,
  columns: _propTypes["default"].array.isRequired,
  defaultSort: _propTypes["default"].shape({
    colId: _propTypes["default"].string,
    order: _propTypes["default"].oneOf([ORDER_ASC, ORDER_DESC])
  }),
  typeBorder: _propTypes["default"].string,
  hover: _propTypes["default"].bool,
  footer: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  sortFn: _propTypes["default"].func,
  isLoading: _propTypes["default"].bool
};
DataTable.defaultProps = {
  tableKey: new Date().valueOf().toString(),
  defaultSort: {
    colId: null,
    order: ORDER_ASC
  },
  typeBorder: null,
  hover: false,
  footer: null,
  onClick: function onClick() {},
  sortFn: function sortFn() {},
  isLoading: false
};
var _default = exports["default"] = DataTable;